'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002eshopping$0024package$0024$002dGrocery$002dItem$002dId$0024 from "./mealorama.shopping$package$-Grocery-Item-Id$.js";
var $p;
/** @constructor */
function $c_Lmealorama_pages_PrepareShoppingPage$State(meals, msgState, ingredients, unitOptions, incompleteIngredients, dialog, stores, store) {
  this.ny = null;
  this.oL = null;
  this.lo = null;
  this.nz = null;
  this.mz = null;
  this.q7 = null;
  this.mA = null;
  this.oM = null;
  this.ny = meals;
  this.oL = msgState;
  this.lo = ingredients;
  this.nz = unitOptions;
  this.mz = incompleteIngredients;
  this.q7 = dialog;
  this.mA = stores;
  this.oM = store;
}
export { $c_Lmealorama_pages_PrepareShoppingPage$State as $c_Lmealorama_pages_PrepareShoppingPage$State };
$p = $c_Lmealorama_pages_PrepareShoppingPage$State.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_pages_PrepareShoppingPage$State;
/** @constructor */
function $h_Lmealorama_pages_PrepareShoppingPage$State() {
}
export { $h_Lmealorama_pages_PrepareShoppingPage$State as $h_Lmealorama_pages_PrepareShoppingPage$State };
$h_Lmealorama_pages_PrepareShoppingPage$State.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, 382765188, true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_pages_PrepareShoppingPage$State)) {
    var x = this.ny;
    var x$2 = x$0.ny;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      var x$3 = this.oL;
      var x$4 = x$0.oL;
      var $x_6 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$5 = this.lo;
      var x$6 = x$0.lo;
      var $x_5 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$7 = this.nz;
      var x$8 = x$0.nz;
      var $x_4 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$9 = this.mz;
      var x$10 = x$0.mz;
      var $x_3 = ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$11 = this.q7;
      var x$12 = x$0.q7;
      var $x_2 = ((x$11 === null) ? (x$12 === null) : x$11.f(x$12));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$13 = this.mA;
      var x$14 = x$0.mA;
      var $x_1 = ((x$13 === null) ? (x$14 === null) : x$13.f(x$14));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$15 = this.oM;
      var x$16 = x$0.oM;
      return ((x$15 === null) ? (x$16 === null) : x$15.f(x$16));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 8;
});
$p.r = (function() {
  return "State";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.ny;
      break;
    }
    case 1: {
      return this.oL;
      break;
    }
    case 2: {
      return this.lo;
      break;
    }
    case 3: {
      return this.nz;
      break;
    }
    case 4: {
      return this.mz;
      break;
    }
    case 5: {
      return this.q7;
      break;
    }
    case 6: {
      return this.mA;
      break;
    }
    case 7: {
      return this.oM;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
$p.aHA = (function() {
  var this$3 = this.lo;
  var f = ((_$1$2) => {
    var this$2 = _$1$2.hl;
    return ((!this$2.b()) && this$2.i().oA);
  });
  _return: {
    var result;
    var l$tailLocal1 = this$3;
    while (true) {
      if (l$tailLocal1.b()) {
        var result = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
        break;
      } else {
        var h = l$tailLocal1.e();
        var t = l$tailLocal1.c();
        if ((!(!(!f(h))))) {
          l$tailLocal1 = t;
          continue;
        }
        var start = l$tailLocal1;
        var remaining$tailLocal1 = t;
        while (true) {
          if (remaining$tailLocal1.b()) {
            var result = start;
            break _return;
          } else {
            var x = remaining$tailLocal1.e();
            if ((!(!f(x)))) {
              remaining$tailLocal1 = remaining$tailLocal1.c();
              continue;
            }
            var firstMiss = remaining$tailLocal1;
            var newHead = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(start.e(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
            var toProcess = start.c();
            var currentLast = newHead;
            while ((toProcess !== firstMiss)) {
              var newElem = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(toProcess.e(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
              currentLast.t = newElem;
              currentLast = newElem;
              toProcess = toProcess.c();
            }
            var next = firstMiss.c();
            var nextToCopy = next;
            while ((!next.b())) {
              var head = next.e();
              if ((!(!f(head)))) {
                next = next.c();
              } else {
                while ((nextToCopy !== next)) {
                  var newElem$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(nextToCopy.e(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
                  currentLast.t = newElem$2;
                  currentLast = newElem$2;
                  nextToCopy = nextToCopy.c();
                }
                nextToCopy = next.c();
                next = next.c();
              }
            }
            if ((!nextToCopy.b())) {
              currentLast.t = nextToCopy;
            }
            var result = newHead;
            break _return;
          }
        }
      }
    }
  }
  var rest = result;
  var h$1 = null;
  var t$1 = null;
  while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
    var it = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Option$().BE(rest.e().hl).nb().n();
    while (it.l()) {
      var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(it.k(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      if ((t$1 === null)) {
        h$1 = nx;
      } else {
        t$1.t = nx;
      }
      t$1 = nx;
    }
    rest = rest.c();
  }
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_SeqOps__distinct__O(((h$1 === null) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$() : h$1)), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$4$2) => {
    $j_mealorama$002eshopping$0024package$0024$002dGrocery$002dItem$002dId$0024.$m_Lmealorama_shopping$package$GroceryItemId$();
    return _$4$2.eI;
  })), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_math_Ordering$String$());
});
$p.aOO = (function() {
  var this$3 = this.lo;
  var f = ((_$5$2) => {
    var this$2 = _$5$2.hl;
    return ((!this$2.b()) && (!this$2.i().oA));
  });
  _return: {
    var result;
    var l$tailLocal1 = this$3;
    while (true) {
      if (l$tailLocal1.b()) {
        var result = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
        break;
      } else {
        var h = l$tailLocal1.e();
        var t = l$tailLocal1.c();
        if ((!(!(!f(h))))) {
          l$tailLocal1 = t;
          continue;
        }
        var start = l$tailLocal1;
        var remaining$tailLocal1 = t;
        while (true) {
          if (remaining$tailLocal1.b()) {
            var result = start;
            break _return;
          } else {
            var x = remaining$tailLocal1.e();
            if ((!(!f(x)))) {
              remaining$tailLocal1 = remaining$tailLocal1.c();
              continue;
            }
            var firstMiss = remaining$tailLocal1;
            var newHead = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(start.e(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
            var toProcess = start.c();
            var currentLast = newHead;
            while ((toProcess !== firstMiss)) {
              var newElem = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(toProcess.e(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
              currentLast.t = newElem;
              currentLast = newElem;
              toProcess = toProcess.c();
            }
            var next = firstMiss.c();
            var nextToCopy = next;
            while ((!next.b())) {
              var head = next.e();
              if ((!(!f(head)))) {
                next = next.c();
              } else {
                while ((nextToCopy !== next)) {
                  var newElem$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(nextToCopy.e(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
                  currentLast.t = newElem$2;
                  currentLast = newElem$2;
                  nextToCopy = nextToCopy.c();
                }
                nextToCopy = next.c();
                next = next.c();
              }
            }
            if ((!nextToCopy.b())) {
              currentLast.t = nextToCopy;
            }
            var result = newHead;
            break _return;
          }
        }
      }
    }
  }
  var m = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_scm_Map$().dB();
  var it = result.n();
  while (it.l()) {
    var elem = it.k();
    var key = elem.hl.i();
    m.I6(key, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_List$();
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_scm_ListBuffer();
    }))).aQ(elem);
  }
  var result$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_HashMap$().uW;
  var mapIt = m.n();
  while (mapIt.l()) {
    var x1 = mapIt.k();
    x1.z();
    x1.E();
    var \u03b42$ = x1;
    var k$2 = \u03b42$.z();
    var v$2 = \u03b42$.E();
    result$1 = result$1.tU(k$2, v$2.aP());
  }
  var this$6 = result$1;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Seq$().n1(this$6), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$8$2) => {
    $j_mealorama$002eshopping$0024package$0024$002dGrocery$002dItem$002dId$0024.$m_Lmealorama_shopping$package$GroceryItemId$();
    return _$8$2.z().eI;
  })), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_math_Ordering$String$());
});
function $isArrayOf_Lmealorama_pages_PrepareShoppingPage$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kv)));
}
export { $isArrayOf_Lmealorama_pages_PrepareShoppingPage$State as $isArrayOf_Lmealorama_pages_PrepareShoppingPage$State };
var $d_Lmealorama_pages_PrepareShoppingPage$State = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_pages_PrepareShoppingPage$State, "mealorama.pages.PrepareShoppingPage$State", ({
  kv: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_pages_PrepareShoppingPage$State as $d_Lmealorama_pages_PrepareShoppingPage$State };
//# sourceMappingURL=mealorama.pages.-Prepare-Shopping-Page$-State.js.map
